import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';
import LoanStore from '@/loan/store';

const loanStore = getModule(LoanStore, store);

export const loanLinkedAccountsResolver = async (): Promise<void> => {
	await loanStore.getAndSetLinkedAccounts();
};
